import React, { useState, useEffect } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { businessInfo } from '../data/mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMobileMenuOpen(false);
    }
  };

  const navItems = [
  { id: 'inicio', label: 'Inicio' },
  { id: 'nosotros', label: 'Nosotros' },
  { id: 'servicios', label: 'Servicios' },
  { id: 'petshop', label: 'Petshop' },
  { id: 'testimonios', label: 'Testimonios' },
  { id: 'contacto', label: 'Contacto' }];


  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-transparent'}`
      }>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-28 md:h-32">
          {/* Logo */}
          <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('inicio')}>
            <img
              src="https://customer-assets.emergentagent.com/job_pawsome-care-53/artifacts/bmqpq05g_Logo_Patas_Club2.png"
              alt="Patas Club Logo"
              className="h-24 md:h-28 w-auto" />

          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navItems.map((item) =>
            <button
              key={item.id}
              onClick={() => scrollToSection(item.id)}
              className="hover:text-teal-600 transition-colors duration-200 !font-medium !text-lg !text-[#0B3535]">

                {item.label}
              </button>
            )}
          </nav>

          {/* Phone Number */}
          <a
            href={`tel:${businessInfo.phone}`}
            className="hidden md:flex items-center gap-2 px-4 py-2 bg-teal-500 text-white rounded-lg hover:bg-teal-600 transition-colors duration-200">

            <Phone className="w-4 h-4" />
            <span className="font-medium">Llamar</span>
          </a>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors">

            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen &&
        <div className="md:hidden pb-4 animate-in slide-in-from-top duration-200">
            <nav className="flex flex-col space-y-3">
              {navItems.map((item) =>
            <button
              key={item.id}
              onClick={() => scrollToSection(item.id)}
              className="text-left px-4 py-2 text-gray-700 hover:bg-teal-50 hover:text-teal-600 rounded-lg transition-colors">

                  {item.label}
                </button>
            )}
              <a
              href={`tel:${businessInfo.phone}`}
              className="flex items-center justify-center gap-2 px-4 py-2 bg-teal-500 text-white rounded-lg hover:bg-teal-600 transition-colors">

                <Phone className="w-4 h-4" />
                <span className="font-medium">Llamar</span>
              </a>
            </nav>
          </div>
        }
      </div>
    </header>);

};

export default Header;